export default {"src":"/_next/static/image/public/images/icons2/4.3fdf59b6d6cf3b5635364c3bc28eee7d.svg","height":24,"width":24};